import React, { useEffect, useState,useRef } from "react";
import "../components/css/newsletter.css";
import { useNavigate } from "react-router-dom";
import downArrow from "../images/orgarrow.svg";
import calendarArrow from '../images/calendar-arrow.svg'
import searchIcon from "../images/search-26233.png";
import tekst from "../images/Tekst_img.png";
import picture from "../images/Picture_img.png";
import movie from "../images/Film_img.png";
import movie2 from "../images/film_img1.png";
import trailer from "../images/Trailer_img.png";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { secondsInDay } from "date-fns";
import upload from '../images/upload_on_cloud.png'
import deleteIcon  from  '../images/delete.png'


function CreateNewsletter() {
  const key = sessionStorage.getItem("key");
  const navigate = useNavigate();
  const [bios, setBios] = useState([{}]);
  const [templateLists, setTemplateLists] = useState([{}]);
  const [selectedMovie, setSelectedMovie] = useState("");
  const [selected, setSelected] = useState(bios);
  const [openSideDiv, setOpenSideDiv] = useState(false);
  const [contentKey, setContentKey] = useState('');
  const [contentEdit, setContentEdit] = useState(false);
  const [orgID, setOrgID] = useState();
  const [movies, setMovies] = useState([{}]);
  const [editText, setEditText] = useState('');
  const [filterParam, setFilterParam] = useState(["name"]);
  const [searchParam] = useState(["name"]);
  const [q, setQ] = useState("");
  const [filmSearch, setFilmSearch ]  = useState([])
  const [chosenFile, setChosenFile] = useState('VÆLG FIL')
  let default_filmID = sessionStorage.getItem('default-filmID')
  const [chosenTemplate, setChosenTemplate] = useState();
  // console.log(chosenTemplate)

  useEffect(() => {
    setChosenTemplate(templateLists[0].html)
  }, [templateLists]);
// call to fetch templates
  useEffect(() => {
    if(key && orgID) { 

    const endpoint =`https://biograf.ebillet.dk/systemnative/report.asmx/man_newsletter_templates_get?Key=${key}&OrgNo=${orgID}`;
     fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      
      })
      .then(res => {    
       return res.json()
      })
      .then(result => {
        setTemplateLists(result)
        console.log(result)
      })
       }
  }, [key,orgID]);



  useEffect(() => {
    const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getorganizers?Key=${key}`;
    if (key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
        .then((res) => {
          if (res.status !== 200) {
            navigate("/");
          }
          return res.json();
        })
        .then((result) => {
          // console.log(result)
          setBios(result);

          // console.log('biograf length',result.length)
          if (result.length === 1) {
          }
          // setMovieNumber(result.map((number) => number.No));
        });
    }
  }, [key]);


  useEffect(() => {
    
  }, [key,orgID]);

  const handleSelect = (e) => {
     let g = e.target.value;
   // console.log(e)
    setOrgID(g.split(" ")[g.split(" ").length - 1]);
    setSelected(e.target.value);
  };

  function handleAside() {
    setOpenSideDiv((current) => !current);
  }

  function handleContentEdit () {
    setContentEdit(true)
  }
  function cancelTekstEdit () {
    setContentKey('')
    setContentEdit(false)
  }
    // console.log( orgID)
function toFindDuplicates(arr) {
    const uniqueElements = new Set(arr);
    // const filteredElements =
    arr.filter((item) => {
      if (uniqueElements.has(item)) {
        // uniqueElements.delete(item);
      } else {
        return item;
      }
    });

    return [...new Set(uniqueElements)];
  }
 
  const data = filmSearch.length ?  filmSearch : movies && toFindDuplicates(movies)
  Object.values(filmSearch  ? filmSearch :  toFindDuplicates(movies) )
// console.log(filmSearch)

 function search(items) {
  
    return items && items.filter((item) => {
     
        if (filterParam == "name") {
            return searchParam.some((newItem) => {
                return (
                  item[newItem] && item[newItem]
                        .toString()
                        .toLowerCase()
                        .indexOf(q.toLowerCase()) > -1
                );
            });
        }
    });
   
   }
  //------ api call for movie search ------------
   useEffect(() => {
    const endpoint1 = `https://biograf.ebillet.dk/systemnative/report.asmx/man_movie_search?Key=${key}&search=${'%25'+q+'%25'}`;
   
      if(key && q ) {
     
      
  
        fetch( endpoint1, {
          method: "GET",
          headers: {
            ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
          },
        })
        .then(res =>  { 
      
          if(res.status === 200) {
            return  res.json() 
  
          }
                
        })
        .then(result => { 
               
           
                if(result) { 
                    // q.length && 
                     setFilmSearch(result)
                }
               
           
        
          
        })
       
      }
   },[key,q])
  //  console.log(q, 'q')
  //  console.log(data, 'data')

  useEffect(() => {
      const endpoint = `https://biograf.ebillet.dk/systemnative/report.asmx/man_getprogram?Key=${key}&strOrganizers=${default_filmID?default_filmID:orgID}`;
     if(key) {
      fetch(endpoint, {
        method: "GET",
        headers: {
          ebilletToken: "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        },
      })
     .then(res =>  {
   
        if(res.status === 200) {
          return   res.json() 

        }
           
      })
      .then(result => setMovies(result.Movies))
    }
  }, [orgID]);
// console.log(contentKey)
// console.log(editText, 'edit text')

const options = [
  { value: 'chocolatefgfgfgfgfgfgfgfgf', label: 'Chocolatefgfgfgfgghbghhhhhhhhhhhhhhhhhhfg' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' },
];

  const handleSubmit = (e) => {
    e.preventDefault();
   console.log(e.target.files[0].name, 'chosen file')
  };

  const inputFileChanged = (e) => {
      console.log(e.target.files[0])
      setChosenFile(e.target.files[0].name)
  //  console.log(e.target.elements.image.files[0], 'chosen file')

  }
    const [files, setFiles] = React.useState([]);

  const onDropHandler = (ev) => {
    ev.preventDefault();

    let file = "";
    if (ev.dataTransfer.items) {
      // Use DataTransferItemList interface to access the file(s)
      file =
        [...ev.dataTransfer.items]
          .find((item: any) => item.kind === "file")
          .getAsFile() ;
    } else {
      // Use DataTransfer interface to access the file(s)
      file = ev.dataTransfer.files[0];
    }
    setFiles([...files, file]);
  };

  function handleTemplateSelect (e) {
    let selected_tmp = e.target.value
setChosenTemplate(templateLists.filter((tmp) =>  { return tmp.Name === selected_tmp })[0].html)
  console.log(  templateLists.filter((tmp) =>  { return tmp.Name === selected_tmp }))
    console.log(e.target.value)
  }
// console.log(chosenTemplate)
  const onDragOver = (ev) => ev.preventDefault();

    const iframeRef = useRef(null);
  useEffect(() => {
    const iframe = iframeRef.current;
  //  console.log(iframe.contentWindow.document, 'iframe')
    // const iframeDoc = iframe?.contentDocument || iframe?.contentWindow.document;

    // const button = iframeDoc?.getElementByClassName('add-button');

    // const handleClick = () => {
    //   console.log("Button clicked inside iframe");
    // };

    // button?.addEventListener("click", handleClick);

    // return () => {
    //   button?.removeEventListener("click", handleClick);
    // };
  }, [key,orgID,chosenTemplate]);



  return (
    <main className="CreateNewsletter">
  
  
   
 
      <section className="newsletterHead">
        <p className="newsletter_title">Opret nyhedsbreve</p>
        <button className="cancel_create">Annuller oprettelse</button>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "20px",
            width: "100%",
          }}
        >
          <div>
            <p className="newsletter_label">Navn på nyhedsbrev</p>
            <input
              className="newsletter_input"
              style={{ width: "248px" }}
              type="text"
            />
          </div>
          {/* <div>{selectedMovie ? selectedMovie : selected}</div> */}
          <div>
            <p className="newsletter_label">Vælg biograf</p>
        
            
            <form
              // className=" text-truncate"
              style={{ width: "248px", backgroundColor: "#f7f7f7" }}
            >
              <div className="movieListBox" style={{ width: "248px" }}>
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                  onChange={handleSelect}
                  value={selectedMovie ? selectedMovie : selected}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    width: "248px",
                    backgroundColor: "#f7f7f7",
                    backgroundImage: `url(${calendarArrow})`,
                    color:'#46484c'
                  }}
                >
                  {bios &&
                    bios.map((item) => {
                      let bb = item.City + " - " + item.Name + " " + item.No;
                      return (
                        <option
                          key={item.id}
                          value={bb}
                          className="text-truncate"
                          style={{
                            // maxWidth: '200px',
                            marginLeft: "10px",
                            fontSize: "16px",
                              width:'100%',
                              whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
                          }}
                        >
                          {item.City} - {item.Name}
                        </option>
                      );
                    })}
                </select>
              </div>
            </form>
          </div>

          <div>
            <p className="newsletter_label">Vælg skabelon</p>
            <form
              className="form "
              style={{ width: "260px", backgroundColor: "#f7f7f7" }}
            >
              <div className="movieListBox" style={{ width: "260px" }}>
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                   onChange={handleTemplateSelect}
                  // value={selectedMovie ? selectedMovie : selected}
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    width: "260px",
                    backgroundColor: "#f7f7f7",
                    backgroundImage: `url(${downArrow})`,
                  }}
                >
           {templateLists &&
              templateLists.sort((a,b) => a.Name > b.Name ? 1 : -1).map((item) => {
                
                return (
                  <option key={item.id} value={item.Name} className="text-truncate"  style={{
                    maxWidth: 200,
                    marginLeft: '10px',
                    fontSize: "16px",                   
                  }}>
                    {item.Name}
                  </option>
                );
              })}
                </select>
              </div>
            </form>{" "}
          </div>
          <div>
            <p className="newsletter_label"></p>
            <button className="newsletter_savbtn">GEM I 'IKKE UDSENDTE'</button>
          </div>
        </div>
      </section>
      <hr style={{ height: "3px", margin: 0 ,width:'100.1%'}}></hr>
      <section style={{display:'grid',gridTemplateColumns:'1fr 0.9fr',paddingLeft:'55px'}}>

         <main>
          {chosenTemplate ? <iframe origin='http://localhost:3000'   ref={iframeRef} id='template-iframe' title='template' min-height='800px' height='800px' width='100%' margin-left='180px' margin-top='5px' src={"data:text/html,"+encodeURIComponent(chosenTemplate)}>   
            
             </iframe> : null}
         </main>
       
        {openSideDiv === true ? (
          <div>
            <aside className="asideContainer">
              { (contentKey === 'a' && contentEdit === true ) ?
              <section style={{position:'relative'}}>
                  <div style={{backgroundColor:'white',width:'500px',margin:'20px 27px',height:'398px',border:'1px solid #ccc'}}>
                                  <ReactQuill theme="snow" value={editText} onChange={setEditText} />
                                
                  </div>
                    <div style={{position:'absolute',bottom:'-48px',right:'27px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               
               : (contentKey === 'b' && contentEdit === true ) ?
               <section>
     
                <div className="chooseContentFilm" style={{margin:'23px 30px 10px 36px'}}>
                  <p className="content_title">Indsæt billede</p>
                  <div className="chooseFileContainer" id="drop_zone" onDrop={onDropHandler} onDragOver={onDragOver} >
                    <div style={{display:'flex'}} >
                     <label for="file-upload" class="custom-file-upload">  {chosenFile}</label>
                  
                     <input id="file-upload" type="file" onChange={(e) => inputFileChanged(e)}/>
                     <div className="uploadImgDiv" style={{}}><img src={upload} alt="" /></div>
                   </div>
                   <p className="drop-here-text">eller træk fil til dette felt</p>
                    <div style={{fontSize:'12px',marginTop:'-25px',color:'green'}}>{files[0] && files[0].name}</div>
                  </div>
                  <div style={{display:'flex',justifyContent:'space-between',marginTop:'50px',marginRight:'16px'}}>
                    <p className="img_arkiv">Billedearkiv</p>
                   <form  className="form " style={{ width: "179px",  }} >
              <div className="movieListBox" >
                <span
                  className="select-line"
                  style={{ backgroundColor: "#8d8d8d" }}
                ></span>

                <select
                  className="form-select text-truncate"
                 value='Nyeste først'
                  style={{
                    height: "40px",
                    border: "1px solid #8d8d8d",
                    backgroundRepeat: "no-repeat",
                    // width: "179px",
                   // backgroundColor: "#f7f7f7",
                    backgroundImage: `url(${downArrow})`,
                  }}
                >
                 <option>Nyeste først</option>
                </select>
              </div>
                   </form>
                  </div>
                  <div className="ImgContainer" style={{marginTop:'16px',borderTop:'1px solid #f7f7f7'}}>

                    <div className="image_arkiv_div">
                      <img style={{height:'70px',width:'52px'}} src={movie} alt="" />
                      <div style={{marginTop:'10px'}}> 
                        <p style={{marginTop:'10px',height:'0px',fontSize:'12px',fontWeight:700,letterSpacing:'0.24px',color:'#101010'}}>movie name</p><p style={{margin:0,fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',color:'#46484c'}}>Uploadet 8/12/24</p></div>
                      <img src={deleteIcon} alt="" style={{marginTop:'25px'}}/>
                    </div>
                    {data && data.map((item) => (
                    <div className="image_arkiv_div">
                      <img style={{height:'70px',width:'52px'}}  src={`https://ebillet.dk/poster/`+item.poster.large}  name={item.name}  alt={item.name}  />
                      <div style={{marginTop:'10px'}}> 
                        <p style={{marginTop:'10px',height:'0px',fontSize:'12px',fontWeight:700,letterSpacing:'0.24px',color:'#101010'}}>{item.name}</p><p style={{margin:0,fontSize:'12px',fontWeight:400,letterSpacing:'0.24px',color:'#46484c'}}>Uploadet 8/12/24</p></div>
                      <img src={deleteIcon} alt="" style={{marginTop:'25px'}}/>
                    </div>
                    ))}
                 
                  </div>

                </div>
                  <div style={{float:'right',marginRight:'32px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               : (contentKey === 'c' && contentEdit === true ) ?
               <section >
                <div className="chooseContentFilm">
                  <p className="content_title">Vælg film</p>
                   <div style={{ position: "relative",width:'402px' }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter film" value={q}   
                    onChange={(e) => setQ(e.target.value)}
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div className="filmImgContainer" style={{}}>
                  
                     {  orgID && search(data) && search(data).filter((a,b) => { return a.name !== b.name}).map((movie,i) => (
                     <div style={{position:'relative',}}>
                    <img   src={`https://ebillet.dk/poster/`+movie.poster.large} id={i} name={movie.name}  alt={movie.name} width='125px' height='185px' />  
                 <button className="filmImgChoose">Vælg</button>                       
                    </div>
                    ))}    

                   
                </div>
                </div>
                  <div style={{float:'right',marginRight:'32px'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
               : (contentKey === 'd' && contentEdit === true ) ?
                <section className="chooseContentFilm">
                  <p className="content_title">Vælg trailer</p>
                   <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter trailer"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                 <div style={{position:'relative',top:'55px',float:'right'}}>
                        <button onClick={cancelTekstEdit} className="tekstContentbtn" style={{marginRight:'10px',width:'141px',backgroundColor:'white',border:'1px solid #982f2f',color:'#982f2f'}}>ANNULLER</button>
                        <button className="tekstContentbtn" style={{width:'93px',backgroundColor:'#982f2f',color:'white'}}>GEM</button>
                    </div> 
               </section>
              :

            <>  
              <div className="allContentContainer">
                <p className="content_title">Vælg inholdstype</p>
                <div style={{ position: "relative" }}>
                  <input
                    className="content_input"
                    type="search"
                    placeholder="Søg efter indholdstype"
                  />
                  <span
                    style={{ position: "absolute", left: "10px", top: "7px" }}
                  >
                    <img height="20px" src={searchIcon} alt="search" />
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "18px",
                    flexWrap: "wrap",
                    marginTop: "80px",
                  }}
                >
                  <div
                    className="content_img_container" onClick={() => setContentKey('a')}
                    style={{ paddingTop: "31px", border: contentKey === 'a' ? '1px solid #982f2f'  : ''}}
                  >
                    <img src={tekst} alt="" />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "7px",
                        width: "100%",
                        height: "22px",
                      }}
                    >
                      <p className="img_title" style={{color: contentKey === 'a' ? '#982f2f' : '',fontWeight: contentKey === 'a' ? 700 : 400}}>Tekst</p>
                    </div>
                  </div>
                  <div
                    className="content_img_container" onClick={() => setContentKey('b')}
                    style={{ paddingTop: "48px",border: contentKey === 'b' ? '1px solid #982f2f'  : '' }}
                  >
                    <img src={picture} alt="" />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "7px",
                        width: "100%",
                        height: "22px",
                      }}
                    >
                      <p className="img_title" style={{color: contentKey === 'b' ? '#982f2f' : '',fontWeight: contentKey === 'b' ? 700 : 400}}>Billede</p>
                    </div>
                  </div>
                  <div onClick={() => setContentKey('c')}
                    style={{ paddingTop: "18px" ,border: contentKey === 'c' ? '1px solid #982f2f'  : ''}}
                    className="content_img_container"
                  >
                    <img src={movie} alt="" />
                    <img src={movie2} alt="" style={{ marginTop: "8px" }} />
                    <div
                      style={{
                        position: "absolute",
                        bottom: "7px",
                        width: "100%",
                        height: "22px",
                      }}
                    >
                      <p className="img_title" style={{color: contentKey === 'c' ? '#982f2f' : '',fontWeight: contentKey === 'c' ? 700 : 400}}>Film</p>
                    </div>
                  </div>
                  <div
                    className="content_img_container" onClick={() => setContentKey('d')}
                    style={{ paddingTop: "53px",border: contentKey === 'd' ? '1px solid #982f2f'  : '' }}
                  >
                    <div
                      style={{
                        width: "84px",
                        height: "56px",
                        borderRadius: "3px",
                        backgroundColor: "#adadad",
                        margin: "auto",
                      }}
                    >
                      <img
                        src={trailer}
                        alt=""
                        style={{ padding: "16px 30px 16px 29px" }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          bottom: "7px",
                          width: "100%",
                          height: "22px",
                          left: 0,
                        }}
                      >
                        <p className="img_title" style={{color: contentKey === 'd' ? '#982f2f' : '',fontWeight: contentKey === 'd' ? 700 : 400}}>Trailer</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <button className="add_content_btn" onClick={handleContentEdit}>Tilføj</button>
</>
 }
            </aside>
          </div>
        ) : null}


          <button onClick={handleAside}>click me</button>
       </section>
    </main>
  );
}

export default CreateNewsletter;
